import React from 'react'
import { Button } from 'primereact/button'

/*
 * Shown by the top-level Sentry.ErrorBoundary when a render throws.
 *
 * The previous fallback was `<p>An error has occurred</p>`, which left the
 * user on a blank page with no indication of what to do. Sentry has already
 * captured the error by the time this renders; this is only about giving the
 * user a way forward.
 */
const ErrorFallback = ({ error, resetError }) => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      textAlign: 'center',
    }}
  >
    <div style={{ maxWidth: '32rem' }}>
      <h2 style={{ marginBottom: '0.75rem' }}>Something went wrong</h2>
      <p style={{ marginBottom: '1.5rem', color: '#6c757d' }}>
        This page ran into an unexpected error. The problem has been reported.
        You can try again, or reload if that does not help.
      </p>

      <div
        style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}
      >
        {/* Re-renders the tree without a full page load, so unsaved state
            elsewhere in the app survives a transient failure. */}
        <Button label='Try again' onClick={resetError} />
        <Button
          label='Reload page'
          className='p-button-secondary'
          onClick={() => window.location.reload()}
        />
      </div>

      {/* Only in development: on production this would show users a stack
          trace they cannot act on. */}
      {process.env.NODE_ENV === 'development' && error ? (
        <pre
          style={{
            marginTop: '1.5rem',
            textAlign: 'left',
            whiteSpace: 'pre-wrap',
            fontSize: '0.75rem',
            color: '#b00020',
          }}
        >
          {error.toString()}
        </pre>
      ) : null}
    </div>
  </div>
)

export default ErrorFallback
